import React from 'react'
import { Button } from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';

export class OfficeRender extends React.Component {

  render() {
    const {step} = this.props
    const mediatoken = localStorage.getItem('mediatoken');
    const mediaUrl = encodeURIComponent(step.content + '?' + mediatoken)

    return (
      <>
        <a target='_blank' href={step.content + '?' + mediatoken}>
                <Button variant="contained" color="secondary" size="large" endIcon={<SendIcon />}>Baixar Arquivo</Button>
        </a>
        <br/>
        <iframe
          className="h-1000 w-1000"
          width="1200px"
          height="700px"
          frameBorder="0"
          title="Excel Render"
          {...this.props}
          src={`https://view.officeapps.live.com/op/embed.aspx?src=` + mediaUrl}
        />
      </>
    )
  }

}
